import apiClient from '../client';
import type { Season, CreateSeasonRequest } from '../../types';

const seasonService = {
  getAll: async () => {
    const response = await apiClient.get<Season[]>('/seasons');
    return response.data;
  },

  getById: async (id: string) => {
    const response = await apiClient.get<Season>(`/seasons/${id}`);
    return response.data;
  },

  create: async (data: CreateSeasonRequest) => {
    const response = await apiClient.post<Season>('/seasons', data);
    return response.data;
  },

  update: async (id: string, data: CreateSeasonRequest) => {
    const response = await apiClient.put<Season>(`/seasons/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/seasons/${id}`);
  },
};

export default seasonService;
